export const avatars = ['user', 'bank', 'mapPin', 'school'];

export const reviewStars = {
  value: 5,
  src: '/icons/star.svg',
};

export const cards = [
  {
    key: 'intro',
    value: '',
  },
  {
    key: 'groups',
    value: '18.000+',
  },
  {
    key: 'activeUsers',
    value: '210.000+',
  },
  {
    key: 'municipalities',
    value: '30+',
  },
];
